import { Moment } from 'moment';
import { UserId } from 'api/models';
import { client } from './client';
import { TaskTimeEntry, TimeEntryBase } from './types';

type TaskTimeEntryCreationRequest = TimeEntryBase & {
  taskId: number;
};

const addTaskTimeEntry = (
  [, userId]: UserId,
  timesheet: Moment,
  entry: TaskTimeEntryCreationRequest,
): Promise<TaskTimeEntry> =>
  client.post(
    `/users/${userId}/timesheets/${timesheet.format('YYYY-MM-DD')}/entries`,
    entry,
  );

export enum TimesheetErrors {
  TimesheetApproved = 'TIMESHEET_APPROVED',
}

export const TimesheetsApi = {
  addTaskTimeEntry,
};
